import { Component } from '@angular/core';
import * as i0 from "@angular/core";
export class SharedComponent {
  static ɵfac = function SharedComponent_Factory(t) {
    return new (t || SharedComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SharedComponent,
    selectors: [["geaui-shared"]],
    decls: 2,
    vars: 0,
    template: function SharedComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "p");
        i0.ɵɵtext(1, "shared works!");
        i0.ɵɵelementEnd();
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharedComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-shared',
      template: '<p>shared works!</p>'
    }]
  }], null, null);
})();
